module.exports = __webpack_public_path__ + "static/media/WEX-BNB.2b637d56.png";